/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import { useNavigate, Link, useParams } from "react-router-dom";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, EmailShareButton } from "react-share";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import * as homePageActions from "../../actions/homePageActions";

const Index = (props) => {

  const { actions, userInfo } = props;
  const { setting } = useSelector((state) => state?.settings);
  const { isAuth } = useSelector((state) => state?.user);
  const { slug } = useParams();
  const history = useNavigate();
  const [ResourcesDetail, setResourcesDetail] = useState([]);
  const [likecount, setlikecount] = useState([]);
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    document.title = ResourcesDetail.title;
    document.querySelector('meta[name="description"]').setAttribute('content', ResourcesDetail.title);

  });

  const getResourcesDetailsData = (page = 1) => {
    agent
      .get(API.LOAD_RESOURCES + "/getResourcesDetails/" + slug, {})
      .then((res) => {
        setResourcesDetail(res.data.data);
        setlikecount(res.data.data.likes_count);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getResourcesDetailsData();
  }, [actions, slug]);

  const prepareHtml = (description = "") => ({
    __html: description,
  });

  const PostResourceHub = async (e) => {
    e.preventDefault();
    if (isAuth) {
      history("/post-resource-hub");
      return;
    }
    setPopupMessage(
      "Thank you for browsing! Help us create a meaningful mentoring engagement for you by registering in one simple step, or login if you already have an account."
    );
    setShowPopup(true);
    setTimeout(() => {
      history("/login");
    }, 2000);
  };


  const Like = async (e, resource_id, status) => {
    e.preventDefault();
    if (isAuth === false) {
      setPopupMessage(
        "Thank you for browsing! Help us create a meaningful mentoring engagement for you by registering in one simple step, or login if you already have an account."
      );
      setShowPopup(true);
      setTimeout(() => {
        history("/login");
      }, 2000);
    }
    agent
      .get(
        API.LOAD_RESOURCES + "/resourceLike/" + resource_id + '/' + status + "/" + userInfo?.id
      )
      .then((res) => {
        if (res.data.data === true) {
          setlikecount(res.data.message);
        }
        if (res.data.data === false) {
          setPopupMessage(res.data.message);
          setShowPopup(true);
        }
      })
      .catch((err) => {
        console.error("Like API error:", err);

        setPopupMessage(
          err?.response?.data?.message ||
          "Something went wrong while liking the resource. Please try again."
        );
        setShowPopup(true);
      });

  };

  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(globalThis.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <>
      <section className="outer_main resourcehubouter">
        <Container>
          <div className="page_content_inner">
            <div className="page_heading px-4 mb-0">
              <h1>{ResourcesDetail.title}</h1>
            </div>
            <div className="d-md-flex py-4 px-4">
              <div className="d-flex align-items-center">
                <div className="resource_user">
                  <img src={ResourcesDetail.user_image} alt="" />
                </div>
                <div className="resource_name ps-3">
                  <span className="d-block name">{ResourcesDetail.user_name}</span>
                  <small className="d-block date pt-1">{ResourcesDetail.date}</small>
                </div>
              </div>
              <div className="ms-auto pt-2 pt-md-0 flex-wrap d-flex  align-items-center">
                {userInfo?.id !== ResourcesDetail.user_id && (
                  <button className="like_link" onClick={(e) => {
                    Like(e, ResourcesDetail.id, 1);
                  }} style={{ border: "none", backgroundColor: "white" }}
                  ><i className="far fa-thumbs-up pe-2"></i> {likecount} likes
                  </button>
                )}
                <ul className="social_links d-flex px-2 px-sm-5">
                  <li>
                    <FacebookShareButton url={globalThis.location.href} quote={ResourcesDetail.title}>
                      <i className="fab fa-facebook-square"></i>
                    </FacebookShareButton>
                  </li>
                  <li>
                    <TwitterShareButton url={globalThis.location.href} title={ResourcesDetail.title} >
                      <i className="fab fa-twitter"></i>
                    </TwitterShareButton>
                  </li>
                  <li>
                    <LinkedinShareButton url={globalThis.location.href} title={ResourcesDetail.title} >
                      <i className="fab fa-linkedin"></i>
                    </LinkedinShareButton>
                  </li>
                  <li>
                    <EmailShareButton url={globalThis.location.href}>
                      <i className="fas fa-envelope-square"></i>
                    </EmailShareButton>
                  </li>
                  <li>
                    <button
                      type="button"
                      onClick={copy}
                      aria-label="Copy link"
                      data-tooltip-id="copy-tooltip-1"
                      data-tooltip-content={copied ? "Copied!" : ""}
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                      }}
                    >
                      <i className="fas fa-link" />
                    </button>
                    {copied && (
                      <ReactTooltip
                        id="copy-tooltip-1"
                        place="right"
                        style={{ backgroundColor: "#ef4343", color: "#fff" }}
                        isOpen={copied}
                      />
                    )}
                  </li>
                </ul>

                {setting?.submit_writeup == 1 &&
                  <button className="btn btn_login " onClick={(e) => {
                    PostResourceHub(e);
                  }}>
                    Submit your write up
                  </button>
                }
              </div>
            </div>

            <img src={ResourcesDetail.image} className="resources_detail_img" alt="" />

            <p className="m-0 pb-3 pb-md-5">
              <div
                dangerouslySetInnerHTML={prepareHtml(
                  ResourcesDetail.description
                )}
              >
              </div>
            </p>

            <div className="d-md-flex py-4">

              <div className="d-flex align-items-center">
                {userInfo?.id !== ResourcesDetail.user_id && (
                  <button style={{ all: "unset", margin: `12px` }} className="like_link" onClick={(e) => {
                    Like(e, ResourcesDetail.id, 1);
                  }}>
                    <i className="far fa-thumbs-up pe-2"></i> {likecount} likes
                  </button>
                )}
                <ul className="social_links d-flex px-2 px-sm-5">
                  <li>
                    <FacebookShareButton url={globalThis.location.href} quote={ResourcesDetail.title}>
                      <i className="fab fa-facebook-square"></i>
                    </FacebookShareButton>
                  </li>
                  <li>
                    <TwitterShareButton url={globalThis.location.href} title={ResourcesDetail.title}>
                      <i className="fab fa-twitter"></i>
                    </TwitterShareButton>
                  </li>
                  <li>
                    <LinkedinShareButton url={globalThis.location.href} title={ResourcesDetail.title} >
                      <i className="fab fa-linkedin"></i>
                    </LinkedinShareButton>
                  </li>
                  <li>
                    <EmailShareButton url={globalThis.location.href}>
                      <i className="fas fa-envelope-square"></i>
                    </EmailShareButton>
                  </li>
                  <li>
                    <button
                      type="button"
                      onClick={copy}
                      aria-label="Copy link"
                      data-tooltip-id="copy-tooltip-1"
                      data-tooltip-content={copied ? "Copied!" : ""}
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                        cursor: "pointer",
                      }}
                    >
                      <i className="fas fa-link" />
                    </button>
                    {copied && (
                      <ReactTooltip
                        id="copy-tooltip-2"
                        place="right"
                        style={{ backgroundColor: "#ef4343", color: "#fff" }}
                        isOpen={copied}
                      />
                    )}
                  </li>
                </ul>
              </div>

              <div className="ms-auto pt-2 pt-md-0 flex-wrap d-flex  align-items-center">
                <Link className="btn btn_login mt-3 mt-sm-0" to={`/resources-details/${ResourcesDetail?.next_slug}`}>Next</Link>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
}

Index.propTypes = {
  actions: PropTypes.object.isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    user_name: PropTypes.string,
    image: PropTypes.string,
    user_email: PropTypes.string,
    user_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
};

function mapStateToProps(state) {
  return {
    userInfo: state.userInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...homePageActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);

